import request from '@/utils/request'

// 查询订单列表
export function listOrder(data) {
  return request({
    url: '/sysOrder/pcList',
    method: 'post',
    data,
  })
}

// 结算
export function settlement(id) {
  return request({
    url: '/system/order/settlement?orderId=' + id,
    method: 'get',
  })
}

// 提交验证
export function updOrderVerify(data) {
  return request({
    url: '/system/verify/updOrderVerify',
    method: 'post',
    data: data,
  })
}

// 根据订单id查询商品验证列表
export function getVerify(query) {
  return request({
    url: '/system/verify/list',
    method: 'get',
    params: query,
  })
}

// 新增订单
export function addOrder(data) {
  return request({
    url: '/system/order',
    method: 'post',
    data: data,
  })
}

// 修改订单
export function updateOrder(data) {
  return request({
    url: '/sysOrder/update',
    method: 'post',
    data: data,
  })
}

// 删除订单
export function delOrder(data) {
  return request({
    url: '/sysOrder/delete',
    method: 'post',
    data,
  })
}

// 获取用户下拉框
export function getOrderUserName(data) {
  return request({
    url: '/sysOrder/getOrderUserName',
    method: 'post',
    data: data,
  })
}
